<div class="badge-list-container">
  <cmx-badge
    *ngFor="let badge of badgeList"
    [badge]="badge"
    [color]="badgeColor"
    [isFormlyField]="false"
    (clickedBadge)="clickEvent($event)"
  ></cmx-badge>
</div>
